import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../../../svgs/error-icon.svg';
import style from './style.module.less';

const SpinnerIcon = ({ className }) => (
  <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 16.5C12.4142 16.5 12.75 16.8358 12.75 17.25V20.25C12.75 20.6642 12.4142 21 12 21C11.5858 21 11.25 20.6642 11.25 20.25V17.25C11.25 16.8358 11.5858 16.5 12 16.5ZM7.75781 15.1816C8.05074 14.8891 8.5256 14.8889 8.81836 15.1816C9.11112 15.4744 9.11086 15.9493 8.81836 16.2422L6.69629 18.3643C6.40337 18.6568 5.92851 18.657 5.63574 18.3643C5.34297 18.0715 5.34321 17.5966 5.63574 17.3037L7.75781 15.1816ZM15.1816 15.1816C15.4744 14.8889 15.9493 14.8892 16.2422 15.1816L18.3643 17.3037C18.6568 17.5966 18.657 18.0715 18.3643 18.3643C18.0715 18.657 17.5966 18.6568 17.3037 18.3643L15.1816 16.2422C14.8892 15.9493 14.8889 15.4744 15.1816 15.1816ZM6.75 11.25C7.16421 11.25 7.5 11.5858 7.5 12C7.5 12.4142 7.16421 12.75 6.75 12.75H3.75C3.33579 12.75 3 12.4142 3 12C3 11.5858 3.33579 11.25 3.75 11.25H6.75ZM20.25 11.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H17.25C16.8358 12.75 16.5 12.4142 16.5 12C16.5 11.5858 16.8358 11.25 17.25 11.25H20.25ZM5.63574 5.63574C5.92852 5.34297 6.40337 5.3432 6.69629 5.63574L8.81836 7.75781C9.11085 8.05074 9.11112 8.5256 8.81836 8.81836C8.5256 9.11111 8.05073 9.11085 7.75781 8.81836L5.63574 6.69629C5.3432 6.40337 5.34298 5.92852 5.63574 5.63574ZM17.3037 5.63574C17.5966 5.34321 18.0715 5.34297 18.3643 5.63574C18.657 5.92852 18.6568 6.40337 18.3643 6.69629L16.2422 8.81836C15.9493 9.11086 15.4744 9.11112 15.1816 8.81836C14.8889 8.5256 14.8891 8.05074 15.1816 7.75781L17.3037 5.63574ZM12 3C12.4142 3 12.75 3.33579 12.75 3.75V6.75C12.75 7.16421 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.16421 11.25 6.75V3.75C11.25 3.33579 11.5858 3 12 3Z'
      fill='#212C36'
    />
  </svg>
);

const StoreRefreshIcon = ({ store }) => {
  const storeRefreshStatus = {
    Idle: { className: 'active-icon', icon: faCheckCircle },
    Queued: { className: 'pending-icon', icon: faClock },
    Updating: { className: 'pending-icon', icon: faClock },
    Error: { className: 'error-icon', icon: faExclamationCircle },
    Unknown: { className: 'status-icon', icon: faQuestionCircle },
  };
  const { isActive, refreshStatus, lastRefreshAttemptedDate, isPending, isManualStore } = store;

  if (!isActive) {
    return <div>- -</div>;
  }

  if (isPending) {
    const { className, icon } = storeRefreshStatus.Idle;
    return <FontAwesomeIcon className={style[className]} icon={icon} />;
  }
  const currentStatus = storeRefreshStatus[refreshStatus];
  if (refreshStatus === 'Queued' || refreshStatus === 'Updating') {
    return <SpinnerIcon className={style['status-spinner']} />;
  }
  if (refreshStatus === 'Error') {
    return <img alt='Error' src={ErrorIcon} />;
  }
  if (!isManualStore && ((!lastRefreshAttemptedDate && refreshStatus === 'Idle') || !currentStatus)) {
    const { className, icon } = storeRefreshStatus.Unknown;
    return <FontAwesomeIcon className={style[className]} icon={icon} />;
  }
  return <FontAwesomeIcon className={style[currentStatus.className]} icon={currentStatus.icon} />;
};

StoreRefreshIcon.propTypes = {
  store: PropTypes.object.isRequired,
};

export default StoreRefreshIcon;
